<template>
    <div id="modal-info-msg" class="modal fade show">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="text-center display-4 py-3">
                        <span>
                            <!-- 完了/OK -->
                            <i v-if="cmpLev == 0" class="text-success fas fa-check-circle"></i>
                            <!-- 警告 -->
                            <i v-if="cmpLev == 1" class="text-danger fas fa-exclamation-circle"></i>
                            <!-- 確認 -->
                            <i v-if="cmpLev == 2" class="text-success fas fa-question-circle"></i>
                            <!-- お気に入り(add) -->
                            <i v-if="cmpLev == 3" class="text-danger fas fa-heart"></i>
                            <!-- お気に入り(delete) -->
                            <i v-if="cmpLev == 4" class="text-muted fas fa-heart"></i>
                        </span>
                    </div>
                    <div class="text-center">
                        {{this.cmpMsg}}
                    </div>
                </div>
                <div v-if="cmpLev == 0" class="modal-footer justify-content-center">
                    <button class="btn btn-success px-5" type="button" data-dismiss="modal">
                        閉じる
                    </button>
                </div>
                <div v-if="cmpLev == 1" class="modal-footer justify-content-center">
                    <button class="btn btn-danger px-5" type="button" data-dismiss="modal">
                        閉じる
                    </button>
                </div>
                <div v-if="cmpLev == 2" class="modal-footer px-2">
                    <div class="container">
                        <div class="row">
                            <div class="col-6">
                                <button class="btn btn-danger btn-block m-0" type="button" @click="handleOKBtn">
                                    次へ
                                </button>
                            </div>
                            <div class="col-6">
                                <button class="btn btn-primary btn-block m-0" type="button" data-dismiss="modal">
                                    閉じる
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="cmpLev == 3" class="modal-footer justify-content-center">
                    <button class="btn btn-danger px-5" type="button" data-dismiss="modal">
                        閉じる
                    </button>
                </div>
                <div v-if="cmpLev == 4" class="modal-footer justify-content-center">
                    <button class="btn btn-secondary px-5" type="button" data-dismiss="modal">
                        閉じる
                    </button>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
    import {EventBus} from 'js/event-bus'

    export default {
        props: {
            msg: String,
            lev: {
                type: Number,
                default: 0
            }
        },
        mounted () {
            EventBus.$on('busOnOpenInfoMsg', info => {
                this.busInfo = info
                this.openThis()
            })

            EventBus.$on('busOnHideInfoMsg', () => {
                this.hideThis()
            })

            $('#modal-info-msg').on('show.bs.modal', () => {
                this.resetThis()
                if (this.busInfo) {
                    this.setBusInfo(this.busInfo)
                    this.busInfo = null
                }
            })

            $('#modal-info-msg').on('shown.bs.modal', () => {
                this.isHidden = false
            })

            $('#modal-info-msg').on('hidden.bs.modal', () => {
                this.isHidden = true
            })
        },
        data () {
            return {
                busInfo: null,
                busMsg: "",
                busLev: 0,
                handle: true,
                emitEvt: "",
                emitData: null,
                isHidden: true
            }
        },
        computed: {
            cmpMsg () {
                return this.handle ? this.msg : this.busMsg
            },
            cmpLev () {
                return this.handle ? this.lev : this.busLev
            }
        },
        methods: {
            sleep () {
                return new Promise(resolve => {
                    let interval = setInterval(()=>{
                        if (this.isHidden) {
                            clearInterval(interval)
                            resolve()
                        }
                    }, 500)
                })
            },
            async sleepOpen () {
                await this.sleep()
                $('#modal-info-msg').modal('show')
            },
            openThis () {
                if (this.isHidden) {
                    $('#modal-info-msg').modal('show')
                } else {
                    this.sleepOpen()
                }
            },
            hideThis () {
                $('#modal-info-msg').modal('hide')
            },
            handleOKBtn () {

                if (this.handle) {
                    this.hideThis()
                    this.$emit('ok')
                } else {
                    EventBus.$emit(this.emitEvt, this.emitData)
                }
            },
            resetThis () {
                this.busMsg = ""
                this.busLev = 0
                this.handle = true
                this.emitEvt = ""
                this.emitData = null
            },
            setBusInfo (info) {
                this.busMsg = info.msg
                this.busLev = info.lev    
                this.handle = false
                this.emitEvt = info.emitEvt ? info.emitEvt : ""
                this.emitData = info.emitData ? info.emitData : null
            }
        }
    }
</script>

<style>

</style>

